import React from 'react';
import { useIntl } from 'react-intl';
import Tag from '@amzn/meridian/tag';
import { BottomQuartileCategory } from './types';
import { TagType } from '@amzn/meridian/tag/tag';

const getDefaultBottomQuartileLabel = (
  bqCategory: BottomQuartileCategory
): string => {
  switch (bqCategory) {
    case BottomQuartileCategory.ONE:
      return 'Bottom 1%';
    case BottomQuartileCategory.TEN:
      return 'Bottom 10%';
    case BottomQuartileCategory.TWENTY_FIVE:
      return 'Bottom 25%';
    default:
      return 'Bottom Quartile';
  }
};

const getBottomQuartileTagType = (
  bqCategory: BottomQuartileCategory
): TagType => {
  switch (bqCategory) {
    case BottomQuartileCategory.ONE:
      return 'error';
    case BottomQuartileCategory.TEN:
      return 'warning';
    case BottomQuartileCategory.TWENTY_FIVE:
      return 'neutral';
    default:
      return 'neutral';
  }
};

interface BottomQuartileTagProps {
  bqCategory: BottomQuartileCategory;
}

const BottomQuartileTag: React.FC<BottomQuartileTagProps> = ({
  bqCategory,
}: BottomQuartileTagProps): React.ReactElement => {
  const intl = useIntl();

  return (
    <div
      data-cy={`bq-tag-${bqCategory.toLowerCase()}`}
      style={{ display: 'contents' }}
    >
      <Tag type={getBottomQuartileTagType(bqCategory)}>
        {intl.formatMessage({
          id: `cs_perfportal_bq_${bqCategory.toLowerCase()}`,
          defaultMessage: getDefaultBottomQuartileLabel(bqCategory),
        })}
      </Tag>
    </div>
  );
};

export default BottomQuartileTag;
